var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "material-pages-wrapper"
  }, [_c('website-header', {
    staticStyle: {
      "position": "absolute"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "master-vision"
  }, [_c('div', {
    staticClass: "aside"
  }, [_c('div', {
    staticClass: "slogan"
  }, [_vm._v(_vm._s(_vm.$t("indexmaterial.slogan")))]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t('indexmaterial.download_appstore_tips')))]), _vm._v(" "), _c('a', {
    staticClass: "dl-link appstore",
    attrs: {
      "target": "_blank",
      "href": _vm.downloads.applestore
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dl-link android",
    attrs: {
      "target": "_blank",
      "href": _vm.downloads.android
    }
  })])])]), _vm._v(" "), _vm.showDownload === false ? _c('div', {
    staticClass: "helpful-tips"
  }, [_vm._v("如遇下載或使用問題，請聯繫我們（"), _c('a', {
    attrs: {
      "href": "mailto:livemetw@liveme.com"
    }
  }, [_vm._v("livemetw@liveme.com")]), _vm._v("）")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "previous-partner"
  }, [_vm._v(_vm._s(_vm.$t("indexmaterial.prevpartner")))]), _vm._v(" "), _c('website-footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "central-gray-backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "left-triangle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-circle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-circle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-rounded-rectangle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "central-circle-bubble"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-left-accessor"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-right-accessor"
  })]);
}];
export { render, staticRenderFns };